import { Box, FormControlLabel, Stack, Switch } from '@mui/material';
import { GazeTrackView } from '../../pages/Ems/Components/Gaze/GazeTrackView';
import { GazeAssessment } from './OnDeviceResult/GazeAssessment';
import { useState } from 'react';
import VideoPlayer from '../VideoPlayer';
import styles from './Gaze.module.css';

export function Gaze({ testDetails }) {
  const gazeUrl = testDetails.gazeVideo;
  const [showVideo, setShowVideo] = useState(false);

  return (
    <Stack sx={{gap: '1rem'}}>
      <div className={styles.gazeTrackViewContainer}>
        <Box sx={{ minWidth: '400px' }}>
            <GazeTrackView originalEyePositions={testDetails.eyePositions} />
        </Box>
      </div>
      {testDetails.gazeResult && (
        <GazeAssessment gazeResult={testDetails.gazeResult} />
      )}
        {gazeUrl && (
          <FormControlLabel
            sx={{ marginLeft: 'auto', marginRight: 'auto' }}
            control={
              <Switch
                value={showVideo}
                onChange={() => setShowVideo(!showVideo)}
              />
            }
            label="Show video"
          />
        )}
          {showVideo ?
             <VideoPlayer
              url={`/strokeTests/${testDetails.uuid}/gazeVideo`}
              height="450px"
              width="795px"
            />
            :
            null
          }
    </Stack>
  );
}
